/**
 * Collect operationally useful browser context for support / contact payloads.
 * Avoids fingerprinting data — no canvas, WebGL, or installed-plugin enumeration.
 */
function normalizePathname() {
  var pathname = window.location.pathname || "/";
  if (pathname.length > 1 && pathname.charAt(pathname.length - 1) === "/") {
    pathname = pathname.slice(0, -1);
  }
  return pathname || "/";
}

function pageContextFromPath(pathname) {
  var p = pathname || "/";
  if (p === "/dashboard" || p.indexOf("/dashboard/") === 0) return "dashboard";
  if (p.indexOf("/settings") === 0) return "settings";
  if (p.indexOf("/onboarding") === 0) return "onboarding";
  if (p.indexOf("/admin") === 0) return "admin";
  if (p === "/" || p === "") return "home";
  return "other";
}

function tenantSkinFromBody() {
  var body = document.body;
  if (!body || !body.className) return "";
  var parts = body.className.split(/\s+/);
  for (var i = 0; i < parts.length; i++) {
    if (parts[i].indexOf("tenant-") === 0) return parts[i];
  }
  return "";
}

function dashboardLayoutSnapshot() {
  var pathname = normalizePathname();
  if (pathname !== "/dashboard" && pathname.indexOf("/dashboard/") !== 0) {
    return {
      dashboardVariant: null,
      dashboardBucket: null,
      dashboardView: null,
      dashboardSearchActive: false,
    };
  }
  var shell = document.querySelector("[data-dashboard-variant]");
  var variant = shell && shell.getAttribute("data-dashboard-variant");
  variant = variant && variant.trim() ? variant.trim() : "";
  var activeTab = document.querySelector(".dash-view-tab--active");
  var view =
    activeTab && activeTab.getAttribute("data-view")
      ? activeTab.getAttribute("data-view").trim()
      : "digest";
  var sp = new URLSearchParams(window.location.search || "");
  var bucketRaw = (sp.get("bucket") || "").trim();
  var bucket =
    bucketRaw === "attention" || bucketRaw === "updates" ? bucketRaw : "";
  var q = (sp.get("q") || "").trim();
  return {
    dashboardVariant: variant,
    dashboardBucket: bucket,
    dashboardView: view || "digest",
    dashboardSearchActive: q.length > 0,
  };
}

export function getBrowserInfo() {
  var root = document.documentElement;
  var theme =
    root && root.getAttribute("data-theme")
      ? root.getAttribute("data-theme").trim()
      : "";
  var accentAttr =
    root && root.getAttribute("data-accent-schema")
      ? root.getAttribute("data-accent-schema").trim()
      : "";
  var accentPalette = accentAttr || "default";
  var reducedMotion =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var pathname = normalizePathname();
  var dash = dashboardLayoutSnapshot();
  var screenObj = window.screen || {};
  var sw = typeof screenObj.width === "number" ? screenObj.width : 0;
  var sh = typeof screenObj.height === "number" ? screenObj.height : 0;
  var screenSize =
    sw > 0 && sh > 0 ? String(sw) + "x" + String(sh) : "";
  var pr = typeof window.devicePixelRatio === "number" ? window.devicePixelRatio : 1;
  var pixelRatio = Math.round(pr * 10) / 10;

  return {
    userAgent: navigator.userAgent,
    platform: navigator.platform || "",
    language: navigator.language || "",
    viewportSize: window.innerWidth + "x" + window.innerHeight,
    screenSize: screenSize,
    pixelRatio: pixelRatio,
    timezone: Intl.DateTimeFormat
      ? Intl.DateTimeFormat().resolvedOptions().timeZone
      : "",
    touchSupport: "ontouchstart" in window,
    currentUrl: window.location.href || "",
    referrer: document.referrer || "",
    theme: theme,
    accentPalette: accentPalette,
    reducedMotion: reducedMotion,
    tenantSkin: tenantSkinFromBody(),
    pageContext: pageContextFromPath(pathname),
    dashboardVariant: dash.dashboardVariant,
    dashboardView: dash.dashboardView,
    dashboardBucket: dash.dashboardBucket,
    dashboardSearchActive: dash.dashboardSearchActive,
  };
}
